import React from 'react'

const LockIcon: React.FC = () => {
  return (
    <svg
      width="20"
      height="28"
      viewBox="0 0 20 28"
      fill="none"
      version="1.1"
      id="svg8"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs id="defs12" />
      <g id="Group 79" transform="translate(-10,-4)">
        <rect
          id="Rectangle 27"
          x="11"
          y="16"
          width="18"
          height="15"
          rx="1"
          fill="#7a82f5"
          stroke="#7a82f5"
          strokeWidth="2"
        />
        <rect id="Rectangle 29" x="19" y="22" width="2" height="5" rx="1" fill="#ffffff" />
        <circle id="Ellipse 10" cx="20" cy="21" r="2" fill="#ffffff" />
        <path
          id="Rectangle 28"
          d="m 14.5,11 c 0,-3.03757 2.4624,-5.5 5.5,-5.5 3.0376,0 5.5,2.46243 5.5,5.5 v 6.5 h -11 z"
          stroke="#7a82f5"
          fill="#ffffff"
          strokeWidth="3"
        />
      </g>
    </svg>
  )
}

export default LockIcon
